<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle> View Document: {{ dialogTitle }}</div>
  <button mat-icon-button class="close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div> 

<mat-dialog-content>
  <div class="gridheight mat-elevation-z8 viewport">
    <table mat-table [dataSource]="documents" class="full-width-table" style="table-layout: fixed;">
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="flex gap-2">
            @if(canShowGridActions){
              <button mat-icon-button color="warn" (click)="onDeleteDocument(element)" style="color: red;">
                <mat-icon>delete</mat-icon>
              </button>
            }
              <!-- <button mat-icon-button (click)="onViewDocument(element)">
                <mat-icon>visibility</mat-icon>
              </button> -->
          </div>
        </td>
      </ng-container>
        <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>Id</th>
        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">
          <a (click)="onDownloadDocument(element)" class="document-link">
            {{ element.name.length > 30 ? (element.name | slice:0:30) + '...' : element.name }}
          </a>     
        </td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let element">{{ element.docTypeName }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    
    @if (documents.length === 0) {
      <div style="color: red;text-align: center;font-weight: 500;">No documents found.</div>
    }
</div>
</mat-dialog-content>  

<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-raised-button color="primary" mat-primary (click)="onClose()">
    Close
  </button>
</mat-dialog-actions>
